module.exports = __webpack_public_path__ + "img/744.66376e18.jpg";